if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      const opener = this.openedBy;
      super.hide();
      // super.hide() focuses the opener, which makes the browser auto-scroll
      // the gallery slider and leaves it between scroll-snap points. The
      // misalignment is invisible at rest but propagates when arrows compute
      // the next position from the current scrollLeft, cropping the slide.
      if (!opener) return;
      const slide = opener.closest('.slider__slide');
      const slider = slide && slide.parentElement;
      if (!slider) return;
      requestAnimationFrame(() => {
        const left = slide.offsetLeft - (slider.clientWidth - slide.offsetWidth) / 2;
        slider.scrollTo({ left: Math.max(0, left) });
      });
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');

      const container = this.querySelector('[role="document"]');
      if(container.clientWidth <= 749) {
        container.scrollTo((activeMedia.width - container.clientWidth) / 2, (activeMedia.height - container.clientHeight) / 2);
      } else {
        container.scrollTo((activeMedia.width - container.clientWidth) / 2, activeMedia.offsetTop - ((container.clientHeight - activeMedia.height) / 2));
      }

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
